/**
 * Pure timestamp-comparison primitives for the notice-receipts monotonic
 * merge (RD-NOTICES-V2). Deliberately split out of `services/noticeReceipts.js`
 * — that file imports `../supabase` at module scope (real client construction),
 * so anything that needs only these pure helpers (every store file's
 * merge-from-server function) imports them from HERE instead, keeping those
 * otherwise-pure, no-database util files safely importable in tests that
 * don't mock supabase.
 */

/** ISO instant comparison: `null`/unparseable loses to any valid instant.
 *  Returns whichever of `a`/`b` is LATER. */
export function maxIso(a, b) {
  const aMs = a ? Date.parse(a) : NaN;
  const bMs = b ? Date.parse(b) : NaN;
  if (Number.isNaN(aMs) && Number.isNaN(bMs)) return null;
  if (Number.isNaN(aMs)) return b;
  if (Number.isNaN(bMs)) return a;
  return bMs > aMs ? b : a;
}

/** True when `candidate` is strictly newer than `current` (both ISO or
 *  null/undefined) — the guard every merge-from-server function uses before
 *  writing, so a stale/out-of-order server row can never move a local stamp
 *  backwards. */
export function isNewerIso(candidate, current) {
  const candidateMs = candidate ? Date.parse(candidate) : NaN;
  if (Number.isNaN(candidateMs)) return false;
  const currentMs = current ? Date.parse(current) : NaN;
  if (Number.isNaN(currentMs)) return true;
  return candidateMs > currentMs;
}
